module.exports = __webpack_public_path__ + "img/95.1.49e94c7f.jpg";